import * as React from 'react'
import { Expander } from '@amzn/dvui/dist/Expander'
import { DecodedText } from '../decodedText/decodedText'
import * as st from './synopsis.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { AtfTreatmentProps } from '../../reducers/features'
import * as cn from 'classnames'
import { isTreatment } from '../../utils/utils'

const DEFAULT_LINE_NUM = 3
const ATF_LINE_NUM = 4
const DEFAULT_EXPANDER_ID = 'synopsisExpander'
const ATF_EXPANDER_ID = 'atfSynopsisExpander'

export interface ISynopsisProps {
  synopsis?: string
  numOfLines?: number
  expanderId?: string
}

export const SynopsisComp = ({
  synopsis,
  numOfLines = DEFAULT_LINE_NUM,
  expanderId = DEFAULT_EXPANDER_ID
}: ISynopsisProps) =>
  !synopsis ? null : (
    <div className={`${stUtility.fullWidth} ${st.btfSynopsis}`} data-automation-id={expanderId} dir="auto">
      <Expander
        className={st.synopsis}
        numOfLines={numOfLines}
        uniqueId={expanderId}>
        <DecodedText string={synopsis}/>
      </Expander>
    </div>
  )

export const Synopsis = SynopsisComp


export interface IATFSynopsisProps extends AtfTreatmentProps {
  synopsis?: string
}

export const AtfSynopsisComp = ({ synopsis, atfTreatment}: IATFSynopsisProps) =>
  !synopsis ? null : (
    <div className="avu-full-width dv-dp-node-synopsis" data-automation-id={'atf-synopsis'}>
      <div className={cn(st.atfSynopsis, {[st.atfSynopsisRedesign]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}>
        <Synopsis
          synopsis={synopsis}
          numOfLines={ATF_LINE_NUM}
          expanderId={ATF_EXPANDER_ID}
        />
      </div>
    </div>
  )

export const AtfSynopsis = AtfSynopsisComp

